import { getReduxKey } from "@fla/common";
import { createRouterMiddleware } from "@lagunovsky/redux-react-router";
import { Action, Middleware, ThunkAction, configureStore } from "@reduxjs/toolkit";
import { TypedUseSelectorHook, useDispatch, useSelector } from "react-redux";
import logger from "redux-logger";
import { persistReducer, persistStore } from "redux-persist";
// import autoMergeLevel2 from "redux-persist/es/stateReconciler/autoMergeLevel2";
import storage from "redux-persist/lib/storage";
import { history } from "utils";

import pkg from "../../package.json";
import { rootLogoutState } from "./initStore";
import rootReducer, { AppActions, RootState } from "./rootReducer";

const debug = process.env.NODE_ENV !== "production";
const rootPersistConfig = {
  key: getReduxKey(pkg.name, "root"),
  version: 1,
  storage: storage,
  blacklist: ["user", "getStarted"],
  // stateReconciler: autoMergeLevel2,
  debug
};
//  debug: process.env.NODE_ENV !== "production",

const routerMiddleware = createRouterMiddleware(history);

const appReducer = (state: RootState | undefined, action: AppActions): RootState => {
  if ((action as any).type === "reset/store") {
    localStorage.clear();
    state = {
      ...rootLogoutState
    };
  }

  return rootReducer(state, action as any);
};

const pReducer = persistReducer<RootState, any>(rootPersistConfig, appReducer);

const store = configureStore({
  reducer: pReducer,
  middleware: getDefaultMiddleware => {
    let middleware: Middleware[] = getDefaultMiddleware({
      serializableCheck: false
    }).prepend(routerMiddleware);

    if (process.env.NODE_ENV === "development") {
      middleware = middleware.concat(logger);
    }

    return middleware;
  }
});

const persistor = persistStore(store);
export { persistor, store };

export type AppDispatch = typeof store.dispatch;
export const dispatch: AppDispatch = store.dispatch;

export type AppStore = typeof store;
export type AppGetState = typeof store.getState;

export type AppThunk<ReturnType = void> = ThunkAction<ReturnType, RootState, unknown, Action<string>>;

export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
